import {styled, TableCell, TableRow} from '@mui/material';

import {orangeColors} from '../../layouts/theme/designSystem';

export interface Props {
  /** `striped`: alternating row backgrounds (legacy tables). `flat`: white row + cells use `BasicTableCell` borders. */
  rowVariant?: 'striped' | 'flat';
}

export const BasicTableRow = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== 'rowVariant',
})<Props>(({rowVariant = 'flat'}) =>
  rowVariant === 'flat'
    ? {
      backgroundColor: '#fff',
      '& .MuiTableCell-root': {
        borderBottom: `1px solid ${orangeColors[3]}`,
      },
    }
    : {
      '&:nth-of-type(odd)': {
        backgroundColor: orangeColors[7],
      },
      '&:nth-of-type(even)': {
        backgroundColor: orangeColors[5],
      },
    }
);

/** Table cell styling for `BasicTableRow` with `rowVariant="flat"` (matches / talent pool). */
export const BasicTableCell = styled(TableCell)(() => ({
  paddingTop: '12px',
  paddingBottom: '12px',
  minWidth: 0,
  fontSize: '13px',
  letterSpacing: '0.39px',
  borderBottom: `1px solid ${orangeColors[3]}`,
}));
